import {ActivityAwardItem} from '../../type';

export type AwardTableVariant =
  | 'betting'
  | 'recharge'
  | 'withdraw'
  | 'count'
  | 'generic';
export type RewardsSource = 'template' | 'awardList';

interface RewardsSourceOptions {
  templateKey?: string;
  activityType?: string;
}

export const getRewardsSource = ({
  templateKey,
}: RewardsSourceOptions): RewardsSource => {
  return templateKey?.startsWith('VIP_') ? 'template' : 'awardList';
};

export const shouldShowRewards = (
  source: RewardsSource,
  templateRewards?: string,
) =>
  source === 'awardList' || !!templateRewards?.replace(/<[^>]*>?/gm, '').trim();

export const getAwardTableVariant = (
  activityType?: string,
  templateKey?: string,
): AwardTableVariant => {
  const resolveVariant = (value?: string): AwardTableVariant | undefined => {
    const normalized = value?.toUpperCase();
    if (!normalized) {
      return undefined;
    }
    if (normalized.includes('COUNT')) {
      return 'count';
    }
    if (normalized.includes('WITHDRAW')) {
      return 'withdraw';
    }
    if (normalized.includes('RECHARGE') || normalized.includes('DEPOSIT')) {
      return 'recharge';
    }
    if (normalized.includes('PURCHASE') || normalized.includes('BET')) {
      return 'betting';
    }
    return undefined;
  };

  if (templateKey?.startsWith('RECHARGE_REBATE')) {
    return 'recharge';
  }
  return (
    resolveVariant(activityType) || resolveVariant(templateKey) || 'generic'
  );
};

const formatAmount = (value?: number) =>
  (Number(value) || 0).toFixed(2).replace(/\.?0+$/, '');

export const buildAwardTableRows = (
  awardList: ActivityAwardItem[],
  variant: AwardTableVariant,
  currency: string,
) =>
  awardList
    .map((item, index) => ({item, index}))
    .sort(
      (a, b) =>
        (Number(a.item.sort) || a.index + 1) -
        (Number(b.item.sort) || b.index + 1),
    )
    .map(({item}) => {
      const minAmount = formatAmount(item.minAmount);
      const maxAmount = formatAmount(item.maxAmount);
      return [
        variant === 'count'
          ? `${minAmount}-${maxAmount}`
          : `${currency}${minAmount}-${currency}${maxAmount}`,
        item.valueType === 'PERCENT_VALUE'
          ? `${formatAmount(item.value)}%`
          : `${currency}${formatAmount(item.value)}`,
      ];
    });
